import { render, staticRenderFns } from "./Withdrawals.vue?vue&type=template&id=9568213e&scoped=true"
import script from "./Withdrawals.vue?vue&type=script&lang=js"
export * from "./Withdrawals.vue?vue&type=script&lang=js"
import style0 from "./Withdrawals.vue?vue&type=style&index=0&id=9568213e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9568213e",
  null
  
)

export default component.exports